import { Environment } from './env.interface';

export const environment: Environment = {
  env: "DEV",
  tokenUrl: "https://wpn-api.postnerd.dev/authentication/login",
  apiBaseUrl: "https://wpn-api.postnerd.dev",
  loginScreenUrl: "https://wpn-cms-web.postnerd.dev/th/auth/login",
  loginScreenRoute: "/auth/login",
  storagePrefix: "wpn-cms-dev-"
};
